"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var arrayToObject_1 = __importDefault(require("../../utils/array/arrayToObject"));
var referralNormalizer = function (response, country, referralCode) {
    var data = {
        referralCode: referralCode,
        country: country,
        referralType: response.referral_type,
        reusable: response.reusable,
    };
    if (response.referral_discounts &&
        Object.values(response.referral_discounts).length &&
        response.referral_discount_restrictions &&
        Object.values(response.referral_discount_restrictions).length) {
        return __assign(__assign({}, data), { referralDiscount: {
                amountByCountry: response.referral_discounts,
                skus: (0, arrayToObject_1.default)(response.referral_discount_restrictions),
            } });
    }
    else if (response.percent_off > 0) {
        return __assign(__assign({}, data), { percentOff: response.percent_off });
    }
    return null;
};
exports.default = referralNormalizer;
